import {memo} from 'react';
import {useWatch} from 'react-hook-form';

import {suffixTestId, TestIdProps} from 'shared/web';

import {VehicleMakeSelect} from '../../ui/components/VehicleMakeSelect';
import {useVehicleCreateMakeModel} from '../hooks/useVehicleCreateMakeModel';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';

export interface MakeSelectProps extends TestIdProps {}

export const MakeSelect = memo<MakeSelectProps>((props: MakeSelectProps = {}) => {
  const {control, vehicleType, baseTestId} = useVehicleFormContext();
  const {createCustomMake} = useVehicleCreateMakeModel();

  // Watch for unknown makes to include them in options
  const unknownMakes = useWatch({
    control,
    name: 'unknownMakes',
  });

  return (
    <VehicleMakeSelect
      isRequired
      control={control}
      vehicleType={vehicleType}
      unknownMakes={unknownMakes ?? []}
      onCreateOption={createCustomMake}
      data-testid={
        props['data-testid'] ? suffixTestId('make-select', props) : `make-select-${baseTestId}`
      }
    />
  );
});

MakeSelect.displayName = 'MakeSelect';
